import { defineComponent as _defineComponent } from 'vue'
import Http from '@/core/http/http.service';
import { store } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PointOfSaleTopBar',
  setup(__props) {

const pointOfSale = computed<PointOfSaleViewObject>(() => store.getters['app/pointOfSale'] || null);

async function signOut() {
    const data = await Http.get<Vertica.LouisPoulsen.Application.PointOfSale.LogoutViewModel>('/pointOfSale/logout');
    window.location.href = data.redirectUrl;
}

function addService() : Promise<void> {
    return store.dispatch('basket/addPointOfSaleService');
}


return { __sfc: true,pointOfSale, signOut, addService }
}

})